import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

// -------

import axios from 'app/services/http/axios';
import {Actions} from './slice';
import { objectToUrl, routePath } from 'app/services/helpers'

import { Api } from 'modules/Admin/Inventory'

// -------

function* getList({payload: {pageNumber, filters}}) {

  try {
    let route = Api.products;
    route += objectToUrl({
      ...filters,
      page: pageNumber,
      with: 'category,type' // Include category and type relationships
    }, true)

    const response = yield call(axios.get, route);
    yield put(Actions.getListSuccess(response));

  } catch (e) {
    return yield put(Actions.getListFailed(e));
  }
}

function* getLowStockProducts() {
  try {
    let route = Api.productsLowStock;
    const response = yield call(axios.get, route);
    yield put(Actions.getLowStockProductsSuccess(response));

  } catch (e) {
    return yield put(Actions.getLowStockProductsFailed(e));
  }
}

function* getFormFilters() {
  try {
    let route = Api.productsFormFilters;
    const response = yield call(axios.get, route);
    yield put(Actions.getFormFiltersSuccess(response));

  } catch (e) {
    return yield put(Actions.getFormFiltersFailed(e));
  }
}

// ------- ACTIONS

function* toDelete({payload: {id}}) {
  try {
    let route = routePath(Api.product, { id });
    const response = yield call(axios.delete, route);
    yield put(Actions.toDeleteSuccess(response));
    toast.success('Product deleted successfully');
  } catch (e) {
    return yield put(Actions.toDeleteFailed(e));
  }
}

function* updateQuantity({payload: {id, quantity, adjustment_type, adjustment_quantity, reason}}) {
  try {
    let route = routePath(Api.productUpdateQuantity, { id });
    const response = yield call(axios.post, route, {
      quantity,
      adjustment_type,
      adjustment_quantity,
      reason
    });
    yield put(Actions.updateQuantitySuccess(response));
    toast.success(`Stock ${adjustment_type === 'add' ? 'added' : 'deducted'} successfully`);
  } catch (e) {
    return yield put(Actions.updateQuantityFailed(e));
  }
}
// -------

export function* watchProductsListSaga() {
  yield takeLatest(Actions.getList.type, getList)
  yield takeLatest(Actions.getLowStockProducts.type, getLowStockProducts)
  yield takeLatest(Actions.getFormFilters.type, getFormFilters)
  yield takeLatest(Actions.toDelete.type, toDelete)
  yield takeLatest(Actions.updateQuantity.type, updateQuantity)
}

export default watchProductsListSaga
